import styled, { device, color } from '@styled'
import { Row } from '@ui/wrapper'

export const SectionWrapper = styled.section`
  padding-block-start: 50px;
  padding-block-end: 50px;
  ${device.medium} {
    padding-block-end: 70px;
  }
  ${device.large} {
    padding-block-end: 90px;
  }
  ${color}
`

export const StyledRow = styled(Row)`
  margin-inline-start: 10px;
  margin-inline-end: 10px;
  ${device.small} {
    margin-inline-start: 34px;
    margin-inline-end: 34px;
  }
`
